import styled from 'astroturf/react';
import { EiqButton } from 'eiq-storybook';

const CapTitle = styled('div')`
  width: 492px;
  height: 25px;
  font-family: var(--ph-font-family-lato-regular);
  font-size: var(--ph-required-title);
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--black);

`;

const CapHeader = styled('div')`
  position: sticky;
  top: -25px;
  background-color: var(--white);
  z-index: 9;
  padding-top: 25px
`;

const CapTabActionRow = styled('div')`
  position: absolute;
  top: 25px !important;
  display: flex;
  column-gap: 15px;
  right: 7rem;
`;

const CapTabRequired = styled('div')`
  /* Layout Properties */
  margin-top: 20px;
  min-width: 300px;
  display: inline-block;
  padding-right: 10px;
  height: auto;
  /* UI Properties */
  background: var(--ph-required-50) 0% 0% no-repeat padding-box;
  border-radius: 2px;
  opacity: 1;
  padding-bottom: 10px;
`;

const CapTabRequiredHeader = styled('div')`
  /* Layout Properties */
  margin-left: 10px !important;
  padding-top: 8px !important;
  width: auto;
  height: 19px;
  /* UI Properties */
  text-align: left;
  font: normal normal bold 16px/18px var(--ph-font-family-lato-regular);
  letter-spacing: 0px;
  color: var(--ph-red-500);
  opacity: 1;
  &:before {
    content: ' ';
    display: inline-block;
    width: 28px;
    height: 16px;
    background: svg-load('../../Svg/icons/icon_error.svg') 0 center no-repeat;
  }
`;

const CapTabRequiredContent = styled('div')`
  margin-top: 20px !important;
  margin-left: 10px !important;
  width: auto;
  height: auto;
  /* UI Properties */
  text-align: left;
  font: normal normal normal 11px/15px var(--ph-font-family-source-sans-pro-regular);
  letter-spacing: 0px;
  color: var(--dark-blue);
  opacity: 1;
`;

const CapTabErrorDetails = styled('div')`
  ul {
    padding-left: 25px;
    font: normal normal normal 11px / 15px var(--ph-font-family-source-sans-pro-regular);
    color: var(--dark-blue);

    li {
      list-style-type: square;
    }
  }
`;

const IndicateRequired = styled('div')`
  font-size: var(--ph-required-indicate);
  color: var(--dark-blue);
  margin-top: 20px;

  &:before {
    content: ' ';
    display: inline-block;
    height: 1em;
    width: 1em;
    clip-path: circle(2px at center);
    background-color: var(--cyan-green);
  }
`;

const SaveButton = styled(EiqButton)`
  width: 80px !important;
  height: 28px !important;
  /* UI Properties */
  background: var(--cyan-green) 0% 0% no-repeat padding-box !important;
  opacity: 1;
  text-align: center;
  font: normal normal bold 13px/15px var(--ph-font-family-lato-regular);
  letter-spacing: 0px;
  color: var(--dark-blue);
  opacity: 1;
`;

const ExportButton = styled(EiqButton)`
  width: 80px !important;
  height: 28px !important;
  opacity: 1;
  text-align: center;
  font: normal normal bold 13px/15px var(--ph-font-family-lato-regular);
  letter-spacing: 0px;
  color: var(--dark-blue);
  opacity: 1;
`;


export default {
  CapTitle,
  CapHeader,
  CapTabActionRow,
  CapTabErrorDetails,
  CapTabRequired,
  CapTabRequiredHeader,
  CapTabRequiredContent,
  IndicateRequired,
  SaveButton,
  ExportButton,
};
